/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Classes for the footer submit button shared by the client, deal and agency
 * profile drawers: auto width (not full-bleed), primary fill, body-size label.
 *
 * The three drawers carried byte-identical copies of this list, so every new
 * drawer added another raw `text-[length:...]` utility to the design-system
 * ratchet. Declared once here, the token-backed typography lives in a single
 * place and new drawers inherit it instead of re-adding the violation.
 */
export const drawerSubmitButtonClass = [
  'h-10 min-w-[7.5rem] px-(--space-5)',
  'bg-(--button-primary-bg) text-(--button-primary-text)',
  'hover:bg-(--button-primary-hover-bg) hover:shadow-[var(--shadow-md)]',
  'text-[length:var(--text-body)]',
  'font-[weight:var(--font-semibold)]',
  'leading-[var(--leading-snug)]',
  'font-[family-name:var(--font-family)]',
  'disabled:cursor-not-allowed disabled:opacity-60',
].join(' ');
